
export const DEBUG_COMPOSITE_OVERLAY = true;
export const DEBUG_STICKER_OUTLINE = true;
export const DEBUG_STICKER_SNAPSHOT = true;
export const COMPOSITE_UTILS_VERSION = "2025-10-29-b";

export const coverSrcRect = (srcW, srcH, dstW, dstH) => {
	const srcAR = srcW / srcH, dstAR = dstW / dstH;
	if (srcAR > dstAR) {
		const sw = srcH * dstAR;
		const sx = (srcW - sw) / 2;
		return { sx, sy: 0, sw, sh: srcH };
	} else {
		const sh = srcW / dstAR;
		const sy = (srcH - sh) / 2;
		return { sx: 0, sy, sw: srcW, sh };
	}
};

export const makeComposite = (container) => {
	const rect = container.getBoundingClientRect();
	const w = Math.max(1, Math.round(rect.width));
	const h = Math.max(1, Math.round(rect.height));
	const dpr = Math.min(window.devicePixelRatio || 1, 2);
	const comp = document.createElement("canvas");
	comp.width = Math.round(w * dpr);
	comp.height = Math.round(h * dpr);
	const ctx = comp.getContext("2d");
	ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
	return { comp, ctx, w, h, dpr };
};

export function drawStickersInto(ctx, w, h, stage) {
  if (!stage) return;
  try { stage.draw(); } catch {}
  let drew = false;
  const layers = stage.getLayers?.() || [];
  for (const layer of layers) {
    if (!layer?.isVisible?.()) continue;
    try { layer.draw(); } catch {}
    const scene = layer.getCanvas?.();
    const c = scene && (scene._canvas || scene.canvas);
    if (c && c.width && c.height) {
      ctx.drawImage(c, 0, 0, w, h);
      drew = true;
    }
  }
  if (!drew && typeof stage.toCanvas === "function") {
    try {
      const snap = stage.toCanvas({ pixelRatio: 1 });
      if (snap) ctx.drawImage(snap, 0, 0, w, h);
    } catch {}
  }
}

export function makeDrawFrame(compCtx, video, webglCanvas, isFront, stickerStage) {
	const { ctx, w, h, dpr } = compCtx;

	return () => {
		ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
		ctx.clearRect(0, 0, w, h);

		const vRect = coverSrcRect(video.videoWidth, video.videoHeight, w, h);
		if (isFront) {
			ctx.save();
			ctx.translate(w, 0);
			ctx.scale(-1, 1);
			ctx.drawImage(video, vRect.sx, vRect.sy, vRect.sw, vRect.sh, 0, 0, w, h);
			ctx.restore();
		} else {
			ctx.drawImage(video, vRect.sx, vRect.sy, vRect.sw, vRect.sh, 0, 0, w, h);
		}

		drawCanvasCroppedToContainer(ctx, { w, h, dpr }, webglCanvas, /* container: */ video.parentElement, { mirror: isFront });

		
	
		drawStickersInto(ctx, w, h, stickerStage);
	};
}


export function drawCanvasCroppedToContainer(ctx, { w, h, dpr }, srcCanvas, container) {
	const cRect = container.getBoundingClientRect();
	const sRect = srcCanvas.getBoundingClientRect(); 

	const left   = Math.max(0, sRect.left   - cRect.left);
	const top    = Math.max(0, sRect.top    - cRect.top);
	const right  = Math.min(cRect.width,  sRect.right  - cRect.left);
	const bottom = Math.min(cRect.height, sRect.bottom - cRect.top );

	const visW = Math.max(0, right - left);
	const visH = Math.max(0, bottom - top);
	if (visW <= 0 || visH <= 0) return;

	const srcScaleX = (sRect.width  > 0) ? (srcCanvas.width  / sRect.width ) : 1;
	const srcScaleY = (sRect.height > 0) ? (srcCanvas.height / sRect.height) : 1;

	const sx = (left  + cRect.left - sRect.left) * srcScaleX;
	const sy = (top   + cRect.top  - sRect.top ) * srcScaleY;
	const sw = visW * srcScaleX;
	const sh = visH * srcScaleY;

	const dx = left;
	const dy = top;
	const dw = visW;
	const dh = visH;

	ctx.drawImage(srcCanvas, sx, sy, sw, sh, dx, dy, dw, dh);
}
